import styled from 'styled-components'

export const CheckBoxLabel = styled.label<{weight: string}>`
    font-weight: ${({weight}) => weight };
    display: block;
    position: relative;
    padding-left: 25px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    :hover input ~ span {
        background-color: ${({theme}) => theme.colors.primary}61;
    }

    input:checked ~ span:after {
        display: block;
    }

    input:checked ~ span {
        background-color: ${({theme}) => theme.colors.primary};
    }

    span::after {
        left: 4px;
        top: 0px;
        width: 2px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`

export const CheckBoxInput = styled.input`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
`

export const CheckBoxMark = styled.span`
    position: absolute;
    top: 2px;
    left: 4px;
    height: 11px;
    width: 11px;
    border-radius: 3px;
    background-color: ${({theme}) => theme.colors.white};
    border: 1px solid ${({theme}) => theme.colors.primary};

    ::after {
        content: "";
        position: absolute;
        display: none;
    }
`